import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';

@Component({
  selector: 'app-textarea',
  templateUrl: './textarea.component.html',
  styleUrls: ['./textarea.component.scss']
})
export class TextareaComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
  }
}
